import { render, staticRenderFns } from "./StoreAlbum.vue?vue&type=template&id=539ed7b3&scoped=true"
import script from "./StoreAlbum.vue?vue&type=script&lang=js"
export * from "./StoreAlbum.vue?vue&type=script&lang=js"
import style0 from "./StoreAlbum.vue?vue&type=style&index=0&id=539ed7b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539ed7b3",
  null
  
)

export default component.exports